import { cssVar } from '@chakra-ui/react';
import { BadgesSchema } from './Badges.styles';

const $arrowBg = cssVar('popper-arrow-bg');
export const badgeStyles: BadgesSchema = {
  flexIconWrapper: {
    bg: 'alpha.700',
    boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.2)',
    border: '1px solid',
    borderColor: 'beta.300',
    h: '7',
    borderRadius: 'md',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'accent',
    cursor: 'pointer',
    gap: '1',
    p: '1',
    w: '75px',
  },
  iconBadge: {
    color: 'beta.300',
    boxSize: '4',
    filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.25))',
    sx: {
      '&&': {
        path: {
          fill: 'beta.300',
        },
      },
    },
  },
  iconTitle: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    lineHeight: '1',
    color: 'white',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.25)',
    textAlign: 'left',
  },
  textTitle: {
    textTransform: 'uppercase',
    fontWeight: 'extrabold',
    fontSize: '2xs',
    color: 'gray.700',
  },
  textDescription: {
    fontSize: '2xs',
    color: 'gray.700',
    fontWeight: 'normal',
  },
  tabs: {
    w: 'full',
    mt: '1',
  },
  tabPanels: {
    mt: '2',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    p: '2',
    pr: '4',
    display: 'block',
    position: 'relative',
    bg: 'white',
    [$arrowBg.variable]: 'white',
    fontFamily: 'accent',
  },
  tabPanelWrapper: {
    bg: 'alpha.500',
    borderRadius: 'md',
    fontSize: 'xs',
    w: 'full',
    sx: {
      p: {
        p: '2',
        color: 'white',
      },
    },
  },
  tabBadge: {
    position: 'relative',
    p: '0',
    pr: '1',
    mr: '1',
    border: 'none',
    color: 'alpha.500',
    _selected: {
      border: 'none',
      '&::after': {
        content: "''",
        position: 'absolute',
        left: '0',
        right: '0',
        margin: 'auto',
        bottom: '-12px',
        width: '5',
        height: '5',
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderTop: '10px solid var(--bc-colors-alpha-500)',
        transform: 'rotate(180deg)',
        clear: 'both',
        zIndex: ['unset', null, 'popover'],
      },
    },
  },
};
